<script setup>
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import { useAlert } from 'dashboard/composables';
import { useUISettings } from 'dashboard/composables/useUISettings';
import RadioCard from 'dashboard/components-next/radioCard/RadioCard.vue';

const { t } = useI18n();
const { isEditorHotKeyEnabled, updateUISettings } = useUISettings();

const hotKeys = computed(() => [
  {
    key: 'enter',
    title: t('PROFILE_SETTINGS.FORM.SEND_MESSAGE.CARD.ENTER_KEY.HEADING'),
    description: t('PROFILE_SETTINGS.FORM.SEND_MESSAGE.CARD.ENTER_KEY.CONTENT'),
    lightImage: '/assets/images/dashboard/profile/hot-key-enter.svg',
    darkImage: '/assets/images/dashboard/profile/hot-key-enter-dark.svg',
  },
  {
    key: 'cmd_enter',
    title: t('PROFILE_SETTINGS.FORM.SEND_MESSAGE.CARD.CMD_ENTER_KEY.HEADING'),
    description: t(
      'PROFILE_SETTINGS.FORM.SEND_MESSAGE.CARD.CMD_ENTER_KEY.CONTENT'
    ),
    lightImage: '/assets/images/dashboard/profile/hot-key-ctrl-enter.svg',
    darkImage: '/assets/images/dashboard/profile/hot-key-ctrl-enter-dark.svg',
  },
]);

const toggleHotKey = key => {
  updateUISettings({ editor_message_key: key });
  useAlert(t('PROFILE_SETTINGS.FORM.SEND_MESSAGE.UPDATE_SUCCESS'));
};
</script>

<template>
  <div
    role="radiogroup"
    :aria-label="t('PROFILE_SETTINGS.FORM.SEND_MESSAGE.TITLE')"
    class="flex flex-col justify-between w-full gap-5 sm:gap-4 sm:flex-row"
  >
    <RadioCard
      v-for="hotKey in hotKeys"
      :id="hotKey.key"
      :key="hotKey.key"
      name="editor_message_key"
      :label="hotKey.title"
      :description="hotKey.description"
      :is-active="isEditorHotKeyEnabled(hotKey.key)"
      class="sm:flex-1"
      @select="toggleHotKey"
    >
      <img
        :src="hotKey.lightImage"
        :alt="hotKey.title"
        class="block object-cover w-full dark:hidden"
      />
      <img
        :src="hotKey.darkImage"
        :alt="hotKey.title"
        class="hidden object-cover w-full dark:block"
      />
    </RadioCard>
  </div>
</template>
